import { MessageBarType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IHtmlText } from '../../../../Models/HtmlTexts/IHtmlText';
import { IHtmlTextItem } from '../../../../Models/HtmlTexts/IHtmlTextItem';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { IHtmlTextsApi } from '../../../../Services/API/HtmlTexts/IHtmlTextsApi';
import * as Services from '../../../../Services/Services';
import { TextEdit } from '../TextEdit/TextEdit';
import { HtmlTextListView } from './TextsListView';

interface ITextsListProps {

}


export const TextsList: React.FunctionComponent<ITextsListProps> = (props) => {

    const [htmlTextList, setHtmlTextList] = React.useState<IHtmlTextItem[]>([]);
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [isPropertiesOpened, setIsPropertiesOpened] = useBoolean(false);
    const [selectedText, setSelectedText] = React.useState<IHtmlText>();

    const [paths, setPaths] = React.useState<string[]>([]);
    const [pathSelected, setPathSelected] = React.useState<string>();

    const selectText = (item: IHtmlTextItem) => {
        loadText(item.path, item.name);
    }

    const loadData = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const textApi = Services.ServicesProvider.GetService<IHtmlTextsApi>(Services.HtmlTextsApi);
        const orders = await textApi.getHtmlTexts();

        if (orders.isSuccess && orders.data) {

            setHtmlTextList(orders.data);
        }
        else {
            setStatusMessage({ message: orders.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const loadPaths = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const textApi = Services.ServicesProvider.GetService<IHtmlTextsApi>(Services.HtmlTextsApi);
        const orders = await textApi.getHtmlTextsPaths();

        if (orders.isSuccess && orders.data) {
            setPaths(orders.data);
        }
        else {
            setStatusMessage({ message: orders.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const loadText = async (path: string, name:string) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IHtmlTextsApi>(Services.HtmlTextsApi);
        const result = await eventTypeApi.getHtmlText(path,name);
        if (result.isSuccess && result.data) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            setSelectedText(result.data);
            setIsPropertiesOpened.setTrue();
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    React.useEffect(() => {
        loadData();
    }, [])

    React.useEffect(() => {
        if (selectedText) {
            setIsPropertiesOpened.setTrue();
        }
        else {
            setIsPropertiesOpened.setFalse();
        }
    }, [selectedText]);

    const refresh = () => {

    }

    const save = async (text: string,title:string) => {
        if (selectedText) {
            setIsLoading.setTrue();
            setStatusMessage(undefined);
            const textApi = Services.ServicesProvider.GetService<IHtmlTextsApi>(Services.HtmlTextsApi);
            const result = await textApi.saveHtmlText(selectedText.path, selectedText.name, title, text);

            if (result.isSuccess) {

                setIsPropertiesOpened.setFalse();
                loadData();
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
            }
            setIsLoading.setFalse();
        }
    }

    return (<>
        <HtmlTextListView items={htmlTextList} isLoading={isLoading} selectItem={selectText} />
        {selectedText && isPropertiesOpened ?
            <TextEdit htmlText={selectedText} save={save} isOpened={isPropertiesOpened} onDismiss={setIsPropertiesOpened.setFalse} /> : null}
    </>
    );
}
